import { makeObservable, observable, runInAction } from 'mobx';

import { RootStore } from '.';
import { BaseStore } from './baseStore';

/** Cross-component signal for "open the chat widget on this conversation" — driven by
 * notification clicks and the `?openChat=` deep-link query param (see ChatWidget). */
export class ChatStore extends BaseStore {
  pendingChannelId: string | null = null;

  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this, {
      pendingChannelId: observable,
    });
  }

  openChannel = (conversationId: string) => {
    runInAction(() => {
      this.pendingChannelId = conversationId;
    });
  };

  clearPendingChannel = () => {
    runInAction(() => {
      this.pendingChannelId = null;
    });
  };
}
